import React from 'react';
import CustomSelection from '../../../../../../customControl/CustomSelection';

const InclusionHeaderRow = ({
    label,
    required = false,
    datalist,
    fieldid,
    onSelectionChange,
    isDisabled = false,
    isActiveDisable = false,
    isSearchable = true,
    isOpen = false,
    onToggle,
    buttonDisabled = false
}) => {
    return (
        <div className="col-lg-12 col-sm-6">
            <div className="row">
                <div className="col-lg-2 col-md-12 mb-1">
                    <label className={`col-form-label ${required ? 'required' : ''}`}>
                        {label}
                    </label>
                </div>
                <div className="col-lg-4 mb-1 col-md-12">
                    <CustomSelection
                        datalist={datalist}
                        fieldid={fieldid}
                        SelectionChange={onSelectionChange}
                        isdisable={isDisabled}
                        isactivedisable={isActiveDisable}
                        issearchable={isSearchable}
                    />
                </div>
                <div className="col-lg-2 mb-1 col-md-12">
                    <button
                        disabled={buttonDisabled}
                        type="button"
                        className="btn btn-primary mx-1"
                        onClick={onToggle}
                        id="btnAdd"
                    >
                        <i className={`fa fa-plus ${isOpen ? "fa-minus" : "fa-plus"}`} aria-hidden="true"></i>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default React.memo(InclusionHeaderRow);

